/** scroll-top.js — shows the back-to-top button after scrolling, smooth-scrolls up. */
const btn = document.querySelector('.footer__totop');
if (btn) {
  const toggle = () => btn.classList.toggle('is-visible', window.scrollY > 400);
  toggle();
  window.addEventListener('scroll', toggle, { passive: true });
  btn.addEventListener('click', () => window.scrollTo({ top: 0, behavior: 'smooth' }));
}
